import { getFirestore, doc, collection, query, where, addDoc, getDoc, getDocs, updateDoc, setDoc, onSnapshot, deleteDoc, documentId } from "firebase/firestore"
import { useAppStore } from '@/stores/appdata'
import { useProfileStore } from '@/stores/profile'
import lazyListener from '@/assets/functions/lazyListener'

let db = getFirestore()
let collectionName = 'profiles/'

// Rôle effectif dans l'organisation courante (même règle que App.vue pour l'utilisateur connecté) :
// le champ global "role" ne reflète pas forcément le rôle dans l'organisation.
function effectiveRole(data) {
  if (data.role === 'SuperAdmin') return 'SuperAdmin'
  let orgId = data.currentOrganisation
  try {
    const profileStore = useProfileStore()
    if (profileStore.profile && profileStore.profile.currentOrganisation) {
      orgId = profileStore.profile.currentOrganisation
    }
  } catch (error) {
    // store pas encore disponible : on garde l'organisation du profil
  }
  if (orgId && data.organisations && data.organisations[orgId] && data.organisations[orgId].role) {
    return data.organisations[orgId].role
  }
  return data.role
}

function docToInstance(document) {
  let data = document.data()
  return data ? new Profile(
    document.id, data.email, data.firstname, data.lastname, data.avatar, data.color,
    effectiveRole(data), data.dev, data.commercial, data.banned, data.activated, data.currentOrganisation, data.currentApps, data.organisations, data.appdata,
    data.created_at, data.activated_at, data.last_login_at, data.last_pwChange_at
  ) : null
}

export default class Profile {
  constructor(id, email, firstname, lastname, avatar, color, role, dev, commercial, banned, activated, currentOrganisation, currentApps, organisations, appdata, created_at, activated_at, last_login_at, last_pwChange_at) {
    this.id = id
    this.email = email
    this.firstname = firstname
    this.lastname = lastname
    this.avatar = avatar
    this.color = color
    this.role = role
    this.dev = dev
    this.commercial = commercial
    this.banned = banned
    this.activated = activated
    this.currentOrganisation = currentOrganisation
    this.currentApps = currentApps
    this.organisations = organisations
    this.appdata = appdata

    this.created_at = created_at
    this.activated_at = activated_at
    this.last_login_at = last_login_at
    this.last_pwChange_at = last_pwChange_at
  }

  static listenById(id, callback) {
    return onSnapshot(doc(db, collectionName, id), snapshot => {
      callback(docToInstance(snapshot))
    })
  }
  static listenAll(callback) {
    return lazyListener(async (onSnapshot) => {
      let appStore = useAppStore()
      let ids = appStore.app.users

      if (ids.length === 0) {
        callback([])
      } else {
        let docsQuery = query(collection(db, collectionName), where(documentId(), 'in', ids))
        onSnapshot(docsQuery, snapshot => {
          let list = []
          snapshot.forEach(document => {
            list.push(docToInstance(document))
          })
          callback(list)
        })
      }
    })
  }
  static listenByRole(role, callback) {
    return lazyListener(async (onSnapshot) => {
      let appStore = useAppStore()
      let ids = appStore.app.users

      if (ids.length === 0) {
        callback([])
      } else {
        let docsQuery = query(collection(db, collectionName), where(documentId(), 'in', ids), where('role', '==', role))
        onSnapshot(docsQuery, snapshot => {
          let list = []
          snapshot.forEach(document => {
            list.push(docToInstance(document))
          })
          callback(list)
        })
      }
    })
  }
  async saveCurrentApp() {
    // updateDoc et non setDoc : setDoc remplaçait tout le profil par le seul champ currentApps
    await updateDoc(doc(db, collectionName, this.id), {
      currentApps: this.currentApps
    })
  }

  static async getById(id) {
    let document = await getDoc(doc(db, collectionName, id))
    return docToInstance(document)
  }
}
